import type { JSX } from 'react'

import { ErrorDescription } from "/app/libraries/arcana/src/blocks/ErrorDescription/index.ts"
import { IconNames } from "/app/libraries/arcana/src/atoms/Icon/index.ts"

import { useUnit } from 'effector-react'
import { locationReplace, model as router } from '~/core/router'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { getErrorMessage, isResolveLoadError, normalizeFrom } from './lib'
import { $isReloading } from './model'

export function Title(): JSX.Element {
  return <AppTitle>Error</AppTitle>
}

ErrorPage.displayName = 'ErrorPage'
export function ErrorPage(): JSX.Element {
  const location = useUnit(router.$location)

  const isReloading = useUnit($isReloading)
  if (isReloading) {
    return <></>
  }

  const state = location?.state
  const search = location?.search ? new URLSearchParams(location.search) : null
  const queryFrom = search ? normalizeFrom(search.get('from')) : undefined
  const queryError = search ? search.get('message') || undefined : undefined

  let from: string | undefined
  let error: string | undefined
  let resolveError = false

  if (state != null && typeof state === 'object') {
    const params =
      'params' in state &&
      state.params != null &&
      typeof state.params === 'object'
        ? (state.params as Record<string, string>)
        : undefined

    // prettier-ignore
    error = 'errorMessage' in state ? getErrorMessage(state.errorMessage)
                 : 'error' in state ? getErrorMessage(state.error)
                                    : undefined
    from = params
      ? `${params.pathname}${params.search}${params.hash}`
      : queryFrom

    if (error && isResolveLoadError(error)) {
      resolveError = true
    }
  }

  from ??= queryFrom
  error ??= queryError

  const handleButtonClick = () => locationReplace(from || '/')

  return (
    <ui.PageWrapper className='error-page'>
      <ErrorDescription
        handleButtonClick={handleButtonClick}
        error={error || (resolveError ? 'Failed to open module' : undefined)}
        from={from}
        buttonTitle={'Update'}
        buttonIcon={IconNames.restart}
      />
    </ui.PageWrapper>
  )
}
